import CrudModule from "@/components/CrudModule";
import { MODULES } from "@/config/modules";
export default function Policies() {
  return (
    <CrudModule module={MODULES.policies} subtitle="Issued policies, commission tracking and retention checkpoints." />
  );
}
